import { createContext, useContext } from 'react';

import type {
  ShipmentCalf,
  ShipmentDetail,
  ShipmentDonor,
  ShipmentEmbryo,
  ShipmentRecipient,
  ShipmentSemen,
} from '@/services/shipping/types';

const ShipmentContext = createContext<{
  embryos: ShipmentEmbryo[];
  semen: ShipmentSemen[];
  donors: ShipmentDonor[];
  recipients: ShipmentRecipient[];
  calves: ShipmentCalf[];
  shipment: ShipmentDetail;
} | null>(null);

export function useShipmentContext() {
  const context = useContext(ShipmentContext);

  if (!context) {
    throw new Error(
      'Shipment.* component must be rendered as child of Shipment component',
    );
  }

  return context;
}

export default ShipmentContext;
